import { store } from "react-easy-state";

const globalStore = store({
  firebase: {},
  sider: {},
  ui: {
    register: {},
    login: {},
    users: {
      show: {},
      edit: {},
    },
    teachers: {
      doubts: {
        index: {},
        show: {},
        pick: {},
      },
    },
    students: {
      doubts: {
        index: {},
        all: {},
        show: {},
        create: {},
        deleteAttachment: {},
      },
      courses: {
        index: {},
        payment: {},
        askdoubt: {},
      },
      course_subscriptions: {
        payment: {},
      },
      subjects: {
        index: {},
      },
      chapters: {
        index: {},
        show: {},
      },
      lectures: {
        show: {}, 
      },
      videos: {
        show: {},
      },
      notes: {
        show: {},
      },
      papers: {
        index: {},
        show: {},
        evaluation: {},
      },
      questionnaires: {
        show: {},
        start: {},
      },
      questions: {
        index: {},
        show: {
          selectedOptionIndices: [],
        },
      },
      schools: {
        index: {},
      },
    },
  },
});

export default globalStore;
